
<span class="popover-span" (wfmOutsideMousedown)="open = false;">
  <span class="trigger" (click)="clickTrigger()">
    <ng-content select="[slot=trigger]"></ng-content>
  </span>
  <div aria-describedby="popover-heading" role="tooltip" class="popover__box" *ngIf="open">
    <div class="popover" [ngClass]="popoverClass" [ngStyle]="widthStyle">
      <div class="popover__header flex flex--right" *ngIf="isHeading">
        <div id="popover-heading" class="popover__heading text-18">
          <strong>{{ headingText }}</strong>
        </div>
      </div>
      <div class="popover__content">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</span>

